<template>
    <div class="divBack">
        <div class="back">
            <div class="widgetHeader"></div>
        </div>
        <v-row class="titleHeader">
            <v-col sm="8" align-self="center">
                <v-icon color="white" class="mr-3" v-if="iconName">
                    {{ 'mdi-' + iconName }}
                </v-icon>
                <span>{{ title }}</span>
            </v-col>

            <v-col sm="4" align="right">
                <button class="rowHeaderProduct">{{ productName }}</button>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import styles from './Header.scss';
export default {
    name: 'Header',
    styles,
    components: {},
    props: {
        productName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            title: '',
            iconName: null,
        };
    },
    watch: {
        $route(to) {
            this.defineTitle(to);
            this.defineIcon(to);
        },
    },
    mounted() {
        this.defineTitle(this.$route);
        this.defineIcon(this.$route);
    },
    methods: {
        defineTitle(route) {
            this.title = route.meta.title ? route.meta.title : 'Seja bem vindo!';
        },
        defineIcon(route) {
            this.iconName = route.meta.icon ? route.meta.icon : null;
        },
    },
};
</script>
